import { render, staticRenderFns } from "./taskSync.vue?vue&type=template&id=d2489562&scoped=true"
import script from "./taskSync.vue?vue&type=script&lang=js"
export * from "./taskSync.vue?vue&type=script&lang=js"
import style0 from "./taskSync.vue?vue&type=style&index=0&id=d2489562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2489562",
  null
  
)

export default component.exports